var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-2"},[_c('div',{staticClass:"home-card"},[_c('h3',{staticClass:"card-title",style:({'background-color':_vm.titleColor})},[_vm._v(_vm._s(_vm.title))]),_c('h3',{staticClass:"card-value"},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }